import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const poiRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/poi-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () => import('./details/poi-details.component'),
    title: 'PAGES.POI.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/poi-details.component'),
    title: 'PAGES.POI.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
